import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { Loader } from "./Loader.tsx";

const LOADER_HOLD_MS = 1000;
const LOADER_FADE_MS = 800;

type Phase = "hold" | "reveal" | "done";

export const Shell = () => {
	const [phase, setPhase] = useState<Phase>(() =>
		window.matchMedia("(prefers-reduced-motion: reduce)").matches
			? "done"
			: "hold"
	);
	useEffect(() => {
		if (phase === "done") return;
		let cancelled = false;

		// Reveal only once the webfonts are ready (capped at 3s), so the
		// headline never repaints mid-reveal with swapped font metrics
		const minimumHold = new Promise((resolve) =>
			window.setTimeout(resolve, LOADER_HOLD_MS)
		);
		const fontsReady = Promise.race([
			Promise.all([
				document.fonts.load('300 40px "Family"'),
				document.fonts.load('300 40px "Family Italic"'),
			]),
			new Promise((resolve) => window.setTimeout(resolve, 3000)),
		]);

		Promise.all([minimumHold, fontsReady]).then(() => {
			if (cancelled) return;
			setPhase("reveal");
			window.setTimeout(() => {
				if (!cancelled) setPhase("done");
			}, LOADER_FADE_MS);
		});

		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<React.Fragment>
			<h1 className="nh-logo fade-in">
				<Link to="/">
					<img
						src="/assets/nh-wordmark.svg"
						alt="Nice Handwriting."
						width={30}
						height={252}
						draggable={false}
					/>
				</Link>
			</h1>
			{phase !== "hold" ? <Outlet /> : null}
			{phase !== "done" ? <Loader done={phase === "reveal"} /> : null}
		</React.Fragment>
	);
};
